import { Type } from "class-transformer";
import { FrontendForm } from "src/modules/sm-base/netgen/FrontendForm";

export class EnaioDocumentWriteFrontendDefinition {
    id: string;
    title: string;
    @Type(() => FrontendForm)
    form: FrontendForm;
}
